import React from 'react';
import { bool, func, shape, string } from 'prop-types';

import MenuItem from '@material-ui/core/MenuItem';

import { fetchSensorTypes } from '../../../actions/sensorTypeActions';
import Select from '../../../components/FormFields/Select';

const MEASUREMENT_TYPES = {
    error:   null,
    loading: false,
    data:    [
        { id: 'Temperature', name: 'Temperature' },
        { id: 'Pressure', name: 'Pressure' },
        { id: 'Humidity', name: 'Humidity' },
        { id: 'MaxTemperature', name: 'Max. Temperature' },
        { id: 'MinTemperature', name: 'Min. Temperature' }
    ]
};

const MeasurementSelect = ({
    errors,
    onBlur,
    onPatch,
    touched,
    values,
    ...props
}) => {

    function handleChange(event) {
        const { value } = event.target;
        const measurementType = MEASUREMENT_TYPES.data.find(
            ({ id }) => id === value
        );
        onPatch({
            measurement: measurementType.id
        });
    }

    return (
        <Select
            error={MEASUREMENT_TYPES.error}
            errors={errors.measurement}
            isLoading={MEASUREMENT_TYPES.loading}
            label="Measurement"
            name="measurement"
            onBlur={onBlur}
            onChange={handleChange}
            required
            touched={touched.measurement}
            value={values.measurement}
            {...props}
        >
            {(MEASUREMENT_TYPES.data || []).map(({ id, name }) => (
                <MenuItem key={id} value={id}>
                    {name}
                </MenuItem>
            ))}
        </Select>
    );
};

MeasurementSelect.defaultProps = {
    errors:  {},
    fetchSensorTypes,
    onBlur:  () => {},
    onPatch: () => {},
    touched: {},
    values:  {}
};

MeasurementSelect.propTypes = {
    errors: shape({
        measurement: string
    }),
    fetchSensorTypes: func,
    onBlur:           func,
    onPatch:          func,
    touched:          shape({
        measurement: bool
    }),
    values: shape({
        measurement: string
    })
};

export default MeasurementSelect;
